import React, { useContext, useEffect, useState } from "react";
import { CiLocationOn } from "react-icons/ci";
import { NavLink, useNavigate } from "react-router-dom";
import { server } from "../../common";
import { toast } from "react-toastify";
import { AxiosError } from "axios";
import { useSelectAccess } from "../../store/stateFunctions";
import { FaLocationDot } from "react-icons/fa6";
import { IoIosArrowForward } from "react-icons/io";
import "./internships.css";
import { CiBookmark } from "react-icons/ci";
import { IoIosBookmark } from "react-icons/io";
import configContext from "../../context/configContext/configContext";

const Internships = () => {
  document.title = "Internships";
  const user = useSelectAccess("Student");
  const [data, setData] = useState([]);
  const [bookmarkedJobs, setBookmarkedJobs] = useState([]);
  const [industryData, setIndustryData] = useState([]);
  const [processing, setProcessing] = useState(false);
  const { setProgress } = useContext(configContext);
  const navigate = useNavigate();

  // const data = [
  //   {
  //     id: 1,
  //     logo: "/images/logo1.png",
  //     company: "The Innovative Solutions",
  //     desc: "Work From Home",
  //     post: "Vendor Relations Manager",
  //   },
  //   {
  //     id: 2,
  //     company: "The Innovative Solutions",
  //     desc: "Work From Home",
  //     post: "Senior UX/UI Designer",
  //   },
  //   {
  //     id: 3,
  //     company: "The Innovative Solutions",
  //     desc: "Work From Home",
  //     post: "Senior Marketer",
  //   },
  //   {
  //     id: 4,
  //     company: "The Innovative Solutions",
  //     desc: "Work From Home",
  //     post: "Field Sales Executive",
  //   },
  //   {
  //     id: 5,
  //     company: "The Innovative Solutions",
  //     desc: "Work From Home",
  //     post: "Telecaller",
  //   },
  //   {
  //     id: 6,
  //     company: "The Innovative Solutions",
  //     desc: "Work From Home",
  //     post: "Senior Marketer",
  //   },
  //   {
  //     id: 7,
  //     company: "The Innovative Solutions",
  //     desc: "Work From Home",
  //     post: "Field Sales Executive",
  //   },
  //   {
  //     id: 8,
  //     company: "The Innovative Solutions",
  //     desc: "Work From Home",
  //     post: "Telecaller",
  //   },
  // ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        await getYuvasarthiData();
        await getIndustryData();
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const addBookmark = (itemId) => {
    if (!user) {
      navigate("/loginstudent");
      toast.dark("Please login to add job to your bookmark");
      return;
    }
    server
      .post(
        `/internship/addbookmark/${itemId}`,
        {},
        {
          headers: {
            Authorization: user.authToken,
          },
        }
      )
      .then(function (response) {
        console.log("Added to Bookmark successfully:", response.data.message);
        toast.success(response.data.message);
        setBookmarkedJobs((prevBookmarkedJobs) =>
          prevBookmarkedJobs.includes(itemId)
            ? prevBookmarkedJobs.filter((id) => id !== itemId)
            : [...prevBookmarkedJobs, itemId]
        );
      })
      .catch(function (error) {
        console.error("Error submitting rating", error);
        toast.error(error.message);
      });
  };

  const addYuvaBookmark = (itemId) => {
    if (!user) {
      navigate("/loginstudent");
      toast.dark("Please login to add job to your bookmark");
      return;
    }
    server
      .post(
        `/internship/admbookmark/${itemId}`,
        {},
        {
          headers: {
            Authorization: user.authToken,
          },
        }
      )
      .then(function (response) {
        console.log("Added to Bookmark successfully:", response.data.message);
        toast.success(response.data.message);
        setBookmarkedJobs((prevBookmarkedJobs) =>
          prevBookmarkedJobs.includes(itemId)
            ? prevBookmarkedJobs.filter((id) => id !== itemId)
            : [...prevBookmarkedJobs, itemId]
        );
      })
      .catch(function (error) {
        console.error("Error submitting rating", error);
        toast.error(error.message);
      });
  };

  const getYuvasarthiData = () => {
    setProcessing(true);
    setProgress(10);
    server
      .get("/internship/getallinternships", {
        headers: {
          "Content-Type": "application/json",
          // Authorization: user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setData(response.data);
          setProgress(100);
        }
        setProcessing(false);
      })
      .catch(function (error) {
        if (error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
        setProcessing(false);
        setProgress(100);
      });
  };

  const getIndustryData = () => {
    setProcessing(true);
    setProgress(10);
    server
      .get("/internship/getallind_internship", {
        headers: {
          "Content-Type": "application/json",
          // Authorization: user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setIndustryData(response.data);
          setProgress(100);
        }
        setProcessing(false);
      })
      .catch(function (error) {
        if (error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
        setProcessing(false);
        setProgress(100);
      });
  };

  const SearchData = (searchValue) => {
    server
      .get(`/internship/searchinternshipdetails?search=${searchValue}`, {
        headers: {
          "Content-Type": "application/json",
          // "auth-token": user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setData(response.data);
          setIndustryData(response.data);
        }
      })
      .catch(function (error) {
        toast.error(error);
      });
  };

  // search filter wise
  const FilterModewiseData = (event) => {
    const selectedValue = event.target.value;
    server
      .get(`/internship/searchinternshipmode?search=${selectedValue}`, {
        headers: {
          "Content-Type": "application/json",
          // Authorization: user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setData(response.data);
          setIndustryData(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else {
          toast.error(error.response.data.error);
        }
      });
  };

  return (
    <>
      <div
        className="container-xl text-decoration-none "
        style={{ marginTop: "1rem" }}
      >
        <div className="row py-2">
          <div className="col-md-6 my-1">
            <input
              type="search"
              className="form-control"
              placeholder="Search"
              onChange={(e) => SearchData(e.target.value)}
            />
          </div>
          <div className="col-md-6 my-1">
            <select
              className="form-control"
              onChange={(e) => FilterModewiseData(e)}
            >
              <option value="online">Online</option>
              <option value="offline">Offline</option>
            </select>
          </div>
        </div>
        <div className="row ">
          {/* yuvasarathi Internships */}
          {data &&
            data?.map((item) => {
              return (
                <>
                  <div
                    className="internship-container col-md-4 my-3"
                    key={item.id}
                  >
                    <div className="internships">
                      <div className="internship p-2">
                        <div className="row" style={{ height: "9rem" }}>
                          <div className="col-md-8">
                            <h5 className="internship-title">
                              {item.position}
                            </h5>
                            <p>{item.company_name}</p>
                          </div>
                          <div className="col-md-2 mt-5 text-center">
                            <img src={item.image} width={100} alt="" />
                          </div>
                        </div>

                        <p>
                          <span className="fw-bold"> Status : &nbsp;</span>
                          <span className="badge bg-warning text-dark p-2">
                            {item.status}
                          </span>
                        </p>
                        <p>
                          <span className="fw-bold">
                            Internship Openings : &nbsp;
                          </span>
                          <span className="">{item.noofposition}</span>
                        </p>
                        <table>
                          <tr>
                            <td>
                              <FaLocationDot className="fs-4 me-2 text-danger " />
                            </td>
                            <td>
                              <p className="my-2">{item.address}</p>
                            </td>
                          </tr>
                        </table>
                        <div className="details text-center">
                          <div className="row p-1">
                            <div className="col m-2 btn btn-outline-info text-dark ">
                              {item.internship_mode} Mode
                            </div>

                            <div className="col m-2 btn btn-outline-info text-dark ">
                              {item.internship_period}
                            </div>
                          </div>
                          <NavLink
                            to={`/internships/${item.id}`}
                            className="banner text-white ms-2 bg-light btn w-75 "
                          >
                            More Details
                          </NavLink>
                        </div>
                        <span className="open-positions">
                          <span
                            className="open-positions"
                            key={item.id}
                            onClick={() => addYuvaBookmark(item.id)}
                          >
                            {bookmarkedJobs.includes(item.id) ? (
                              <CiBookmark />
                            ) : (
                              <IoIosBookmark />
                            )}
                            {/* <IoIosBookmark /> */}
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                </>
              );
            })}

          {/* industry internships */}
          {industryData &&
            industryData
              ?.filter((items) => items.status === "Post")
              .map((items) => {
                return (
                  <>
                    {items.status === "Post" ? (
                      <div
                        className="internship-container col-md-4 my-3"
                        key={items.id}
                      >
                        <div className="internships">
                          <div className="internship p-2">
                            <div className="row" style={{ height: "9rem" }}>
                              <div className="col-md-8">
                                <h5 className="internship-title">
                                  {items.position}
                                </h5>
                                <p>{items.company_name}</p>
                              </div>
                              <div className="col-md-2 mt-5 text-end">
                                <img src={items.image} width={100} alt="" />
                              </div>
                            </div>

                            <p>
                              <span className="fw-bold"> Status : &nbsp;</span>
                              <span className="badge bg-warning text-dark p-2">
                                {items.status1}
                              </span>
                            </p>
                            <p>
                              <span className="fw-bold">
                                Internship Openings : &nbsp;
                              </span>
                              <span className="">{items.noofposition}</span>
                            </p>
                            <table>
                              <tr>
                                <td>
                                  <FaLocationDot className="fs-4 me-2 text-danger " />
                                </td>
                                <td>
                                  <p className="my-2">{items.address}</p>
                                </td>
                              </tr>
                            </table>
                            <div className="details text-center">
                              <div className="row p-1">
                                <div className="col m-2 btn btn-outline-info text-dark ">
                                  {items.internship_mode} Mode
                                </div>

                                <div className="col m-2 btn btn-outline-info text-dark ">
                                  {items.internship_period}
                                </div>
                              </div>
                              <NavLink
                                to={`/industryinternships/${items.id}`}
                                className="banner text-white ms-2 bg-light btn w-75 "
                              >
                                More Details
                              </NavLink>
                            </div>
                            <span className="open-positions">
                              <span
                                className="open-positions"
                                key={items.id}
                                onClick={() => addBookmark(items.id)}
                              >
                                {bookmarkedJobs.includes(items.id) ? (
                                  <IoIosBookmark />
                                ) : (
                                  <CiBookmark />
                                )}
                                {/* <IoIosBookmark /> */}
                              </span>
                            </span>
                          </div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </>
                );
              })}
        </div>
      </div>
    </>
  );
};

export default Internships;
